export const MEDIA_QUERY_WIDTH = 650;
export const MEDIUM_MEDIA_QUERY_WIDTH = 850;

const border = 'none';
export const buttonGhostLinkStyles = {
  bg: 'transparent',
  border,
  variant: 'ghost',
  _active: { border },
  _focus: { border },
  _hover: { background: 'none' },
};

export const inputErrorMessageStyles = {
  color: 'red.dark',
  fontSize: 'md',
  fontWeight: 'normal',
};

export const fullPageCenterContentWrapperStyles = {
  alignItems: 'center',
  bottom: '0',
  left: '0',
  height: '100%',
  justifyContent: 'center',
  position: 'absolute',
  right: '0',
  top: '0',
  width: '100%',
};
